export default {
  Title: 'Professional Certifications/Licenses',
  Subtitle: 'Select any professional certifications/licenses completed or in progress. For each one, tell us where you earned it and the year.',
  SelectedCount: 'Certifications Selected (#{count}):',
  AvailableCertifications: {
    PSW: 'Personal Support Worker (PSW)',
    DSW: 'Developmental Service Worker (DSW)',
    PAB: 'Préposé aux bénéficiaires (PAB)',
    CNA: 'Certified Nursing Assistant (CNA)',
    HCA: 'Health Care Aide (HCA)',
    RNA: 'Registered Nursing Assistant (RNA)',
    RPN: 'Registered Practical Nurse (RPN)',
    RN: 'Registered Nurse (RN)',
    CPR: 'CPR Certification',
    firstAid: 'First Aid Certification',
    pswStudent: 'PSW Student',
    nursingStudent: 'Nursing Student',
  },
  IssuingOrgOrSchool: 'Issuing Organization/School *',
  IssuingOrgOrSchoolPlaceholder: 'e.g., George Brown College',
  AvailableOrgsAndSchools: [
    'George Brown College',
    'Humber College',
    'Centennial College',
    'Seneca College',
    'Mohawk College',
    'Douglas College',
    'Fanshawe College',
    'Collège Boréal',
    'St. Lawrence College',
    'Northern College',
    'Conestoga College',
    'Durham College',
    'Cambrian College',
    'Red Cross Training Centre',
    'Canadian Red Cross',
    'American Red Cross',
    'St. John Ambulance',
    'Heart and Stroke Foundation',
    'American Heart Association',
    'University of Toronto',
    'McMaster University',
    'Toronto Metropolitan University',
    'Western University',
    'Johns Hopkins University',
    'University of Pennsylvania',
  ],

  Country: 'Country *',
  CountryPlaceholder: 'Select country',
  AvailableCountries: {
    US: 'United States',
    CA: 'Canada',
  },
  ProvinceOrState: 'Province/State *',
  ProvinceOrStatePlaceholder: 'Select province/state',
  SubdivisionCA: {
    AB: 'Alberta',
    BC: 'British Columbia',
    MB: 'Manitoba',
    NB: 'New Brunswick',
    NL: 'Newfoundland and Labrador',
    NS: 'Nova Scotia',
    NT: 'Northwest Territories',
    NU: 'Nunavut',
    ON: 'Ontario',
    PE: 'Prince Edward Island',
    QC: 'Quebec',
    SK: 'Saskatchewan',
    YT: 'Yukon',
  },
  SubdivisionUS: {
    AL: 'Alabama',
    AK: 'Alaska',
    AZ: 'Arizona',
    AR: 'Arkansas',
    CA: 'California',
    CO: 'Colorado',
    CT: 'Connecticut',
    DE: 'Delaware',
    FL: 'Florida',
    GA: 'Georgia',
    HI: 'Hawaii',
    ID: 'Idaho',
    IL: 'Illinois',
    IN: 'Indiana',
    IA: 'Iowa',
    KS: 'Kansas',
    KY: 'Kentucky',
    LA: 'Louisiana',
    ME: 'Maine',
    MD: 'Maryland',
    MA: 'Massachusetts',
    MI: 'Michigan',
    MN: 'Minnesota',
    MS: 'Mississippi',
    MO: 'Missouri',
    MT: 'Montana',
    NE: 'Nebraska',
    NV: 'Nevada',
    NH: 'New Hampshire',
    NJ: 'New Jersey',
    NM: 'New Mexico',
    NY: 'New York',
    NC: 'North Carolina',
    ND: 'North Dakota',
    OH: 'Ohio',
    OK: 'Oklahoma',
    OR: 'Oregon',
    PA: 'Pennsylvania',
    RI: 'Rhode Island',
    SC: 'South Carolina',
    SD: 'South Dakota',
    TN: 'Tennessee',
    TX: 'Texas',
    UT: 'Utah',
    VT: 'Vermont',
    VA: 'Virginia',
    WA: 'Washington',
    WV: 'West Virginia',
    WI: 'Wisconsin',
    WY: 'Wyoming',
  },
  City: 'City *',
  CityPlaceholder: 'e.g., Toronto',
  CurrentlyInProgress: 'Currently in progress',
  YearObtained: 'Year Obtained *',
  YearExpected: 'Year Expected *',
  LicenseOrRegistrationNumber: 'License/Registration # (optional)',
  LicenseOrRegistrationNumberPlaceholder: 'e.g. 12345',
  ExpiryDate: 'Expiry Date (optional)',
  RemoveButton: 'Remove',
  SaveButton: 'Save',
};
